import DomainCommon from './common';

const CityService = {
    list: () => {
        return new Promise((resolve, reject) => {
            return DomainCommon.fetchGet({
                url: `${DomainCommon.getUecareApiUrl()}/city`,
                resolve, reject
            });
        });
    },
    findById: (groupId) => {
        return new Promise((resolve, reject) => {
            return DomainCommon.fetchGet({
                url: `${DomainCommon.getUecareApiUrl()}/city/${groupId}`,
                resolve, reject
            });
        });
    },
    listAll: () => {
        return new Promise((resolve, reject) => {
            return DomainCommon.fetchGet({
                url: `${DomainCommon.getUecareApiUrl()}/city/full`,
                resolve, reject
            });
        });
    },
};

export default CityService;



// WEBPACK FOOTER //
// ./src/service/city.js